<template>
  <div ref="barChart" class="bar-chart" :style="{ height: chartHeight }"></div>
</template>

<script>
import * as echarts from "echarts";

export default {
  props: {
    chartData: {
      type: Array,
      default: [],
      //   required: true,
    },
    chartLabels: {
      type: Array,
      default: [],
      //   required: true,
    },
    chartHeight: {
      type: String,
      default: "400px",
    },
  },
  watch: {
    chartData(newData) {
      this.updateChart(newData, this.chartLabels);
    },
    chartLabels(newLabels) {
      this.updateChart(this.chartData, newLabels);
    },
  },
  mounted() {
    this.initChart();
    this.updateChart(this.chartData, this.chartLabels); // 初始化图表数据
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    updateChart(labels, data) {
      if (this.chartInstance) {
        this.chartInstance.setOption({
          grid: {
            left: "15%",
            right: "0%",
            top: "10%",
            bottom: "14%",
          },
          title: {
            text: "项目类型",
          },
          tooltip: {},
          xAxis: {
            type: "category",
            data: labels,
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              name: "金额",
              type: "bar",
              data: data,
            },
          ],
        });
      }
    },
    initChart() {
      this.chartInstance = echarts.init(this.$refs.barChart);
    },
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },
  },
};
</script>

<style scoped>
.bar-chart {
  width: 100%;
}
</style>
